import style from '../../grid-page.module.less';
import PagingControlWrapper from '../PagingControlWrapper';

type SuppliersPagingWrapperProps = {
  totalRecords: number;
};

export const SuppliersPagingWrapper = ({ totalRecords }: SuppliersPagingWrapperProps) => {
  return (
    <div className={style['paging-footer']}>
      <PagingControlWrapper totalRecords={totalRecords} />
    </div>
  );
};
